<template>
  <mdb-modal v-if="visible" centered @close="$emit('cancel')" elegant>
    <mdb-modal-header>
      <mdb-modal-title class="isi-heading-blue">
        {{ isUpdate ? 'Update Review' : 'Write a new review' }}
      </mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body>
      <mdb-input
        label="Project Number"
        v-model="localReview.projectNumber"
        class="mb-3"
      />
      <mdb-input
        label="Project Name"
        v-model="localReview.projectName"
        class="mb-3"
      />
      <mdb-input
        label="Review Title"
        v-model="localReview.title"
        class="mb-3"
      />
      <mdb-input
        type="textarea"
        label="Review Content"
        v-model="localReview.message"
        :rows="6"
      />
    </mdb-modal-body>
    <mdb-modal-footer>
      <mdb-btn color="secondary" @click="handleCancel">Cancel</mdb-btn>
      <mdb-btn
        color="isi"
        :disabled="!localReview.projectNumber || !localReview.projectName || !localReview.title || !localReview.message"
        @click="handleSubmit"
      >
        {{ isUpdate ? 'Update Review' : 'Submit Review' }}
      </mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
export default {
  name: 'ReviewEditorModal',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    review: {
      type: Object,
      required: true
    },
    modalTitle: {
      type: String,
      default: 'Write a new review'
    }
  },
  data() {
    return {
      localReview: { ...this.review }
    };
  },
  watch: {
    review: {
      handler(newVal) {
        this.localReview = { ...newVal };
      },
      immediate: true
    }
  },
  methods: {
    handleCancel() {
      this.$emit('cancel');
    },
    handleSubmit() {
      this.$emit('submit', { ...this.localReview });
    }
  },
  computed: {
    // determines if this is editing an existing review
    isUpdate() {
      return this.localReview.id != null && this.localReview.createdAt != null;
    }
  }
};
</script>

<style scoped>
/* You can add specific styles for the editor modal if needed */
</style>